<template>
  <div>
    <el-button type="primary"
               v-if="show"
               @click="getCode"
               :disabled="!status"
               :size="type">{{ $t('user.activation') }}</el-button>
    <el-button v-else
               type="info"
               size="medium"
               class="timing-info-cla">{{ numCount }} s</el-button>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: Boolean
    },
    isShow: {
      type: Boolean
    },
    type: {
      type: String,
      default: 'small'
    }
  },

  data () {
    return {
      show: true,
      timer: null,
      numCount: 60
    }
  },
  methods: {
    getCode () {
      if (!this.timer) {
        this.$emit('toGetCode')
        return
      }
      if (this.isShow) {
        return
      }
      this.show = false
      this.timer = setInterval(() => {
        this.numCount--
        if (this.numCount === 0) {
          clearInterval(this.timer)
          this.timer = null
          this.numCount = 60
          this.show = true
        }
      }, 1000)
    },
    beginTime () {
      if (this.timer) {
        return
      }
      this.show = false
      this.timer = setInterval(() => {
        this.numCount--
        if (this.numCount === 0) {
          clearInterval(this.timer)
          this.timer = null
          this.numCount = 60
          this.show = true
        }
      }, 1000)
    },
    clearTimer () {
      clearInterval(this.timer)
      this.timer = null
      this.show = true
      this.numCount = 60
    }
  },
  mounted () { }
}
</script>

<style scoped lang="less">
.timing-info-cla {
  width: 80px;
  min-width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/timing.vue